import { createElement as h } from "react"

import { FormControlLabel, Radio } from "@mui/material"
import { makeStyles } from "@mui/styles"
import T from "prop-types"
import { prop } from "ramda"
import { cx } from "ramda-extension/es"

import { Palette } from "../../../lib/_private"

export const useRadioStaticOverrides = makeStyles(({ typography }) => ({
  root: {
    "& $svg": { color: "#757575", fontSize: typography.pxToRem(24) },
    color: "#757575",
  },
}))

export const useRadioDynamicOverrides = makeStyles(({ withPalette }) => ({
  checked: ({ color }) => ({
    "&.Mui-checked": {
      color: withPalette(color, Palette.isSecondary(color) ? "contrastText" : "main"),
    },
  }),
  disabled: ({ checked, color }) => {
    return {
      "&.Mui-disabled": {
        color: `${withPalette(!checked ? "main" : color ? color : "primary")} !important`,
      },
    }
  },
}))

export const useLabelStaticOverrides = makeStyles(({ typography }) => ({
  label: {
    "&.MuiTypography-root": {
      color: typography.color,
      fontSize: typography.pxToRem(14),
      fontWeight: 700,
    },
  },
  root: {
    "& > span": {
      padding: "8px",
    },
    marginBottom: 0,
    width: "fit-content",
  },
}))


export const LabeledRadio = ({ checked, className, color, disabled, label, onChange, value, dataQa, ...props }) => {
  return h(FormControlLabel, {
    className,
    classes: useLabelStaticOverrides(),
    ["data-qa"]: dataQa ? `label-${dataQa}` : undefined,

    control: h(Radio, {
      inputProps:{
        ...props,
      },
      checked,
      className,

      classes: {
        checked: cx(
          prop("checked", useRadioStaticOverrides),
          prop("checked", useRadioDynamicOverrides({ color })),
          prop("disabled", useRadioDynamicOverrides({ checked, color })),
        ),

        root: cx(
          prop("root", useRadioStaticOverrides),
          prop("root", useRadioDynamicOverrides({ color })),
        ),
      },

      color: "default",
      disabled,
      onChange,
      value,
    }),

    label,
  })
}

LabeledRadio.propTypes = {
  checked: T.bool,
  className: T.string,
  color: T.string,
  disabled: T.bool,
  label: T.string,
  onChange: T.func,
  value: T.any,
}

LabeledRadio.defaultProps = {
  color: "primary",
}
